/*
 * Module for the Death Beneficiary Detail Step of the MemberDirect Shared Form Steps wizard
*/
rs.module("content/communications/onlineforms/sharedformsteps/deathbeneficiarydetailstep",

    ["common/select-helper", "common/visibility" ],

    function (selectHelper, visibility) {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var personNonPersonRadioContainer = stepContainer.js(jsSelectors.personNonPersonRadioContainer, { required: false });
            var personContainer = stepContainer.js(jsSelectors.personContainer);
            var nonPersonContainer = stepContainer.js(jsSelectors.nonPersonContainer);
            var useMembersAddressCheckbox = stepContainer.js(jsSelectors.useMembersAddressCheckbox);
            var addressContainer = stepContainer.js(jsSelectors.addressContainer);

            // Handle the personNonPersonRadio changed event
            personNonPersonRadioContainer.find("input").on("click", () => personNonPersonRadioChanged());

            // Initialize visibility based on radio selection
            function personNonPersonRadioChanged() {
                
                var isPerson = personNonPersonRadioContainer.find("input:checked").val();

                // Set container visibility based on user selection
                visibility.setVisible(personContainer, isPerson == "true");
                enableDisableSectionFields(personContainer, isPerson == "true")

                visibility.setVisible(nonPersonContainer, isPerson == "false");
                enableDisableSectionFields(nonPersonContainer, isPerson == "false")
            }

            // Handle useMembersAddressCheckbox changed
            useMembersAddressCheckbox.change(function () {

                var useMembersAddress = useMembersAddressCheckbox.is(":checked");

                visibility.setVisible(addressContainer, !useMembersAddress);
                enableDisableSectionFields(addressContainer, !useMembersAddress)
            });

            //
            // Helper method to disable all fields in a container
            //
            function enableDisableSectionFields(containerSelector, enabled) {

                // disable all non-hidden inputs in the section
                containerSelector.find("input").not("[type=hidden]").prop("disabled", !enabled).clearErrors();

                // Have to use select helper to disable any selects
                containerSelector.find("select").each(function () {
                    $(this).clearErrors();
                    selectHelper.getHelper($(this)).setDisabled(!enabled);
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);